import person from './img/person.jpg';
import bitcoin from './img/bitcoin.jpg';
import bitcoin2 from './img/bitcoin2.jpg';
import bitcoin3 from './img/bitcoin3.jpg';

const blogs = [
    {
        id: 1,
        name: 'Lorem Ipsum',
        image: person,
        title: 'How To Sell Bitcoin'
    },
    {
        id: 2,
        name: 'Jane Doe',
        image: bitcoin,
        title: 'How To Sell Bitcoin'
    },
    {
        id: 3,
        name: 'John Doe',
        image: bitcoin2,
        title: 'How To Sell Bitcoin'
    },
    {
        id: 4,
        name: 'Sarah Doe',
        image: bitcoin3,
        title: 'How To Sell Bitcoin'
    }
]

export default blogs;